module.exports = __webpack_public_path__ + "components/wave-graph-scale/static/metric-01d27afd0e3aaf81236060002f6f399b.svg";